import React, { useState } from 'react';

import styled from 'styled-components';

import Button from 'components/lib/Button';

import UserManagementUserModal from '../UserManagementUserModal';

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  padding-top: 2px;
`;

const UserManagementAddUserButton = () => {
  const [open, setOpen] = useState(false);

  return (
    <Container>
      <Button
        type="primary"
        icon={<img src="/icons/add.svg" height={22} width={22} alt="add" />}
        onClick={() => setOpen(true)}
        data-test-id="user-management-add-user-button"
      >
        Add User
      </Button>
      {open && <UserManagementUserModal open={open} onClose={() => setOpen(false)} mode="create" />}
    </Container>
  );
};

export default UserManagementAddUserButton;
